import { btnTd } from '@/api/typing';
import { reactive } from 'vue';
import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import {
  delete_order_used_record,
  start_order_used_record,
  end_order_used_record,
} from '@/api/mjstore-model';
import { message, Modal, notification } from 'ant-design-vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
import modalBox from '@/components/form-modal/modal-tools';
import moment from 'moment';
export const event_obj = mitt();
export const btn_list = [
  {
    name: '作废',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.is_delete == false;
    },
    cb: (record: any) => {
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '作废',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: false,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'datepicker',
              name: 'date',
              label: '作废日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD HH:mm:ss',
              valueFormat: 'YYYY-MM-DD HH:mm:ss',
              showTime: true,
              placeholder: '请选择作废日期',
            },
          ],
          rules: {
            shop_id: [{ required: true, message: '请选择执行门店' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            date: [{ required: true, message: '请选择作废日期' }],
          },
          model: {
            org_id: current_org?.id,
            order_used_record_id: record.id,
            shop_id: record.shop_id,
            staff_id: record.staff_id,
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            delete_order_used_record({
              ...payload,
              org_id: current_org?.id,
              order_used_record_id: record.id,
            })
              .then((res: any) => {
                if (res.show_message) {
                  Modal.warning({
                    title: res.show_message,
                  });
                } else {
                  message.success('作废成功');
                  event_obj.emit('refresh');
                  Object.assign(record, res);
                  resolve(null);
                }
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '开始时间',
    clazz: 'primary',
    is_show: (record: any) => {
      return (
        record.is_delete == false &&
        record.card__project_type__p_type != 21 &&
        record.project__project_type__p_type != 20
      );
    },
    cb: (record: any) => {
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '开始时间',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: false,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_ids',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'multiple',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'datepicker',
              name: 'start_datetime',
              label: '开始时间',
              disabled: false,
              allowClear: true,
              defaultValue: '',
              showTime: true,
              placeholder: '请选择开始时间',
            },
            {
              type: 'remoteselect',
              name: 'bed_id',
              label: '床位',
              disabled: false,
              placeholder: '请选择床位',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-bed',
            },
          ],
          rules: {
            shop_id: [{ required: true, message: '请选择执行门店' }],
            staff_ids: [{ required: true, message: '请选择执行人' }],
            start_datetime: [{ required: true, message: '请选择开始时间' }],
          },
          model: {
            org_id: current_org?.id,
            order_used_record_id: record.id,
            shop_id: record.shop_id,
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            start_order_used_record({
              ...payload,
              org_id: current_org?.id,
              order_used_record_id: record.id,
            })
              .then(res => {
                notification.success({
                  message: '成功',
                  description: '更新成功',
                });
                Object.assign(record, res);
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '结束时间',
    clazz: 'primary',
    is_show: (record: any) => {
      return (
        record.is_delete == false &&
        record.card__project_type__p_type != 21 &&
        record.project__project_type__p_type != 20
      );
    },
    cb: (record: any) => {
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '结束时间',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
          },
          fields: [
            {
              type: 'datepicker',
              name: 'end_datetime',
              label: '结束时间',
              disabled: false,
              allowClear: true,
              defaultValue: '',
              showTime: true,
              placeholder: '请选择结束时间',
            },
          ],
          rules: {
            end_datetime: [{ required: true, message: '请选择结束时间' }],
          },
          model: {
            org_id: current_org?.id,
            order_used_record_id: record.id,
          },
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            end_order_used_record({
              ...payload,
              org_id: current_org?.id,
              order_used_record_id: record.id,
            })
              .then(res => {
                notification.success({
                  message: '成功',
                  description: '更新成功',
                });
                Object.assign(record, res);
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
